<template>
	<div class="ReDashServiceStage col-xl-3 col-lg-4 col-sm-6 col-6 pl-0">
		<div class="stage"> 
			<div class="stageTitle minicard cursor-pointer" @click="GoToServices('srv_oncontrol=true&srv_new=true&srv_inwork=true&srv_arhiv=true')">
				<p>{{strStageTitle}}</p>
			</div>

			<div class="frstRow border-gradient mt-auto">
				<div class="conversion"><p>{{ConvercPr1}}%</p></div>
				<div class="minicard border-bg">
					<p class="numbers">+{{objStage[strStageTitle].all_serv}}</p>
				</div>
			</div>
			<div class="onInWork minicard cursor-pointer" @click="GoToServices('srv_new=true&srv_inwork=true')">
			    <p class="numbers">{{objStage[strStageTitle].serv_on_work}}</p>
			</div>
			<div class="onControl minicard cursor-pointer" @click="GoToServices('srv_oncontrol=true')">
			    <p class="numbers">{{objStage[strStageTitle].serv_on_control}}</p>
			</div>
			<div class="lost minicard cursor-pointer" @click="GoToServices('srv_arhiv=true')">
			    <p class="numbers">{{objStage[strStageTitle].serv_on_archive}}</p>
			</div>            
		</div>

	</div>
</template>

<script>

	export default {
		name: 'ReDashServiceStage',
		components: {

		},
		props: {
			objStage: Object,
			prev_objStage: Object,			
			findId: {
				type: String,
				default: '',
			},
			stages_json_list:String,
			BP_ID: [String, Number],
		},
		data () {
			return {
				ver: 1,
				objGetParams: {},
			}
		},
		computed: {
			strStageTitle: function(){
				let objKeys = Object.keys(this.objStage);
				return objKeys[0];
			},
			strStageTitlePrev: function(){
				let objKeys = Object.keys(this.prev_objStage);
				return objKeys[0];
			},
			ConvercPr1: function(){ 
			    if(this.strStageTitlePrev!='' && this.strStageTitlePrev!='zero'){
				return this.$GVO.str_replace('.0','',(this.objStage[this.strStageTitle].all_serv*100/this.prev_objStage[this.strStageTitlePrev].all_serv).toFixed(1)); 
			    }else{
				return '100';
			    } 
			},
			masStageList: function(){
				return this.$GVO.SafeParseJson(this.stages_json_list);
			}
			
		},
		methods: {
			GoToServices(status){
				this.objGetParams = this.$GVO.GetAllGet();
				for (const key in this.objGetParams) {
					if (Object.hasOwnProperty.call(this.objGetParams, key)) {
						if(key == 'p' || key == 'c2p' || key == 'bp_id' || key == 'stage_id' || (status.indexOf(key) != -1) ) {
							delete this.objGetParams[key];
						}
					}
				}
				const stage_id = this.getStageIdByName(this.strStageTitle);
				let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1)+'&bp_id='+this.BP_ID+'&stage_id='+stage_id+'&'+status;
				//console.log(strItogGetParams);
				location.href = '/data/services?'+strItogGetParams;
			},
			getStageIdByName(strStageName){
				for (let i = 0; i < this.masStageList.length; i++) {
					if(Object.keys(this.masStageList[i])[0] == strStageName) return this.masStageList[i][strStageName];
				}
				return false;
			}
		},
		created(){
			this.objGetParams = this.$GVO.GetAllGet();
		}
	}
</script>

<style scoped>
	.stage {height: 100%; display: flex; flex-direction: column; padding: 0 15px;}
	.ReDashServiceStage p {margin-bottom: 0px;}
	.minicard {padding: 10px; border-radius: 6px; margin-bottom: 15px; height: 68px;}
	.stageTitle {text-align: center; background-color: #01b0e0; height: 68px; display: flex; align-items: center; justify-content: center;}
	.stageTitle p {color: #fff;}
	.numbers {font-size: 30px; text-align: right;}
	.frstRow {display: flex; flex-direction: column; margin-bottom: 15px; position: relative; border: 1px solid #00bf9a; border-radius: 6px; box-shadow: 0px 0px 10px rgba(0, 191, 154, 0.4);}
	.frstRow .minicard {margin-bottom: 0px;}
	.onControl {border: 1px solid#ff8d72; display: flex; align-items: center; flex-direction: column;}
	.onControl p:first-child, .lost p:first-child  {margin-right: 5px;}
	.onInWork {border: 1px solid#728dFF; display: flex; align-items: center; flex-direction: column;}
	.onInWork p:first-child, .lost p:first-child  {margin-right: 5px;}	
	.dummy {opacity: 0;}
	.lost {border: 1px solid#f84e54; display: flex; align-items: center; flex-direction: column;}

	/*.border-gradient {
		background: linear-gradient(to left, #db7272, #8b637f, #5a71ae);    
		box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.74);
		border-radius: 6px;
		padding: 1px;         
	}  pretty gradient*/
	.border-bg {background: #27293d;}
	.white-content .card:not(.card-white) .border-bg {background: #ffffff;}
	/*.white-content .card:not(.card-white) .border-gradient {box-shadow: none;} pretty gradient*/
	.white-content .card:not(.card-white) .frstRow {box-shadow: none;}
	.white-content .card:not(.card-white) .conversion {background: #ffffff;}
	.conversion {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;    
		width: 54px;
		height: 38px;
		border: 1px solid #5C70A4;
		border-right: 1px solid transparent;
		border-radius: 6px 0px 0px 6px;
		background: #27293d;
		text-align: center;
		left: -10px;
		top: 10px;
		z-index: 2;
	}
	.conversion p {font-size: 18px; margin-left: 7px;}
	.conversion:after {
		position: absolute;
		content: '';    
		border-right: 1px solid #5C70A4;   
		border-top: 1px solid #5C70A4;   
		width: 30px;
		height: 30px;
		transform: rotate(45deg);
		border-radius: 6px;
		right: -15px;
		z-index: 1;
	}

	@media (max-width: 768px){
		.stage {padding-left: 0;}
	}

</style>
